import resume from '../assets/pdf/resume.pdf'
import profile from '../assets/png/profile.png'

export const headerData = {
    name: 'Sainath Kadam',
    title: "",
    desciption:"~Life is a journey, not a straight path — and neither is problem-solving. Embrace challenges, stay curious, and grow with every experience. This is your one chance to build something meaningful.",
    image: profile,
    resumePdf: resume
}
